// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';

export const DatePicker = AntDatePicker.generatePicker<Date>(dateFnsGenerateConfig);
